/**
 * Группа фильтра: label + control (Select, tabs, input и т.д.).
 * Единая структура для всех страниц.
 */
import '../../styles/components/filters.css'

export default function FilterGroup({ label, children, className = '' }) {
  return (
    <div className={`filter-group ${className}`.trim()}>
      {label && <span className="filter-group-label">{label}</span>}
      <div className="filter-group-control">{children}</div>
    </div>
  )
}
